import { render, staticRenderFns } from "./VennDiagram.vue?vue&type=template&id=736296d4&scoped=true"
import script from "./VennDiagram.vue?vue&type=script&lang=js"
export * from "./VennDiagram.vue?vue&type=script&lang=js"
import style0 from "./VennDiagram.vue?vue&type=style&index=0&id=736296d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736296d4",
  null
  
)

export default component.exports